module.exports = __webpack_public_path__ + "img/allergy-tree-nuts.98a137ea.png";